/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

    /***
    SEARCH HEADER
    ***/
    function updateSearchPopdownLeft() {
        const popdown = document.querySelector('.header__mobile__button .is-open .search-popdown');
        if (popdown) {
            const width = popdown.offsetWidth;
            const leftValue = document.body.clientWidth <= 749
                ? -(width - 92)
                : -(width - 98);
            popdown.style.left = leftValue + 'px';
        }
    }

    function resetSearchPopdownLeft() {
        const popdown = document.querySelector('.search-popdown');
        if (popdown) {
            const width = popdown.offsetWidth;
            const leftValue = document.body.clientWidth <= 749
                ? (width + 92)
                : (width + 98);
            popdown.style.left = leftValue + 'px';
        }
    }

    document.addEventListener('click', function(e) {
        if (e.target.closest('header-search-popdown')) {
            setTimeout(updateSearchPopdownLeft, 50);
        }
        if (e.target.closest('header-search-popdown .search-popdown__close__button')) {
            resetSearchPopdownLeft();
        }
    });

    window.addEventListener('resize', function() {
        updateSearchPopdownLeft();
    });

    const htmlEl = document.documentElement;

    const observer = new MutationObserver(() => {
        if (!htmlEl.hasAttribute('data-scroll-locked')) {
            resetSearchPopdownLeft();
        }
    });

    observer.observe(htmlEl, {
        attributes: true,
        attributeFilter: ['data-scroll-locked']
    });


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
